/*
 * @Author: luting
 * @Date: 2022-04-13 09:45:10
 * @lastEditors: luting
 * @LastEditTime: 2023-08-14 09:33:16
 */

import { availableDiskType, diskConfigType } from 'root/pages/DiskConfig/diskTypes';

import _ from 'lodash';

// 通过传递进来的总数 与数组对象  计算出未分配的区域  添加是否可更该属性 ， 将 非supos使用 的数据计算出来
const getUnallocatedBlock = (data: availableDiskType[], totalCount: number) => {
  // 未分配的总数
  const residueCount: number = totalCount - data.reduce((pre, cur) => pre + Number(cur.size), 0);
  const size = data.reduce((pre, cur) => {
    let number = pre;
    if (cur.suposPath === 0) {
      number = pre + Number(cur.size);
    }

    return number;
  }, 0);
  // 计算其他的其可用空间总和
  const availableSize = data.reduce((pre, cur) => {
    let number = pre;
    if (cur.suposPath === 0) {
      number = pre + Number(cur.size);
    }

    return number;
  }, 0);
  const tempDiskArr: availableDiskType[] = data.filter((item) => item && item.suposPath !== 0);
  if (size > 0) {
    tempDiskArr.push({
      lvPath: '',
      maxSize: '',
      minSize: '',
      mountPoint: '其他',
      order: null,
      size: parseFloat(size.toFixed(2)),
      suposPath: 0,
      usedSize: '1',
      availableSize: parseFloat(availableSize.toFixed(2)),
    });
  }
  if (residueCount > 0) {
    tempDiskArr.push({
      mountPoint: '',
      size: parseFloat(residueCount.toFixed(2)),
      usedSize: '0',
      lvPath: '',
      minSize: '0',
      maxSize: '0',
      suposPath: 3,
      isChange: true,
      order: null,
    });
  }

  return tempDiskArr;
};

const judgeTotalSize = (data: diskConfigType) => {
  const { totalSize, mountPoints } = data;
  const size = mountPoints.reduce((pre, cur) => pre + Number(cur.size), 0);
  return {
    difference: totalSize - size,
    result: size > totalSize,
  };
};

const getSameLvPath = (data: availableDiskType[], vgName: string) => {
  const indices: any = [];

  const tempData = _.groupBy(data, 'lvPath');
  for (const key in tempData) {
    if (Object.prototype.hasOwnProperty.call(tempData, key)) {
      if (tempData[key].length > 1) {
        // name 为supos相关的目录，allName为所有的拼接的相同lvPath的目录字符串（鼠标移入的时候显示）
        let name = `${vgName}(`;
        let cache = {};
        let suposPath = 0;
        let allName = `${vgName}(`;
        let hasOther = false;

        tempData[key].forEach((item: any) => {
          allName = allName + item.mountPoint + ',';
          cache = item;
          // 有一项数据suposPath为1,合并后的数据suposPath就是1,
          if (item.suposPath) {
            suposPath = item.suposPath;
            name = name + item.mountPoint + ',';
          } else {
            hasOther = true;
          }
        });

        indices.push({
          ...cache,
          mountPoint: hasOther
            ? name.substring(0, name.length - 1) + ',...)'
            : name.substring(0, name.length - 1) + ')',
          allName: allName.substring(0, allName.length - 1) + ')',
          suposPath,
          hasOther,
        });
        name = '';
        allName = '';
      } else {
        indices.push({
          ...tempData[key][0],
        });
      }
    }
  }

  return indices;
};

export { getUnallocatedBlock, judgeTotalSize, getSameLvPath };
